import { toDateTime } from "src/shared/time";

export const formatDate = (date: BackendFormatDateString) => {
  return toDateTime(date).toFormat("LL/dd/yyyy");
};
